import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import Clarity from '@microsoft/clarity';

Clarity.init('xekesxwdjs');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
